import { Component, Input, OnInit } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { filter, finalize, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';

import { MonitorHub } from '../../../shared-module/hubs/monitor.hub';
import { Mp4ConvertionProgress } from '../../../core/models/entities/mp4-to-webm-convertion-progress.type';
import { AppConstants } from '../../../app.constants';
import { PlaylistItemDTO } from '../../../core/models/view-models/playlist-item-models/playlist-item-dto.model';
import { PresentationConvertionModel } from '../../../core/models/entities/presentation-convertion.type';
import { PlaylistDialogMessagesEnum } from '../../../core/enums/toastr-messages/playlist-dialog-messages.enum';

@Component({
  selector: 'files-progress-bar',
  standalone: true,
  imports: [
    AsyncPipe,
    NgClass,
    MatProgressBarModule
  ],
  templateUrl: './files-progress-bar.component.html',
  styleUrl: './files-progress-bar.component.scss'
})
export class FilesProgressBarComponent implements OnInit {
  mp4FileConverted$: Observable<Mp4ConvertionProgress>;
  mp4PortraitToLandscapeConverted$: Observable<Mp4ConvertionProgress>;
  presentationFileConverted$: Observable<PresentationConvertionModel>;

  transformedItemsAmount: number = AppConstants.ZERO_NUMBER;
  convertingMessage: string;

  @Input() item: PlaylistItemDTO;
  @Input() sourceIndex: number = AppConstants.ZERO_NUMBER;
  @Input() percentage: number;
  @Input() showDetails: boolean;
  @Input() showSimplifiedDetails: boolean;
  @Input() isRecentFilesTab: boolean;

  constructor(
    private monitorHub: MonitorHub
  ) {}

  ngOnInit(): void {
    this.mp4FileConverted$ = this.monitorHub.mp4ToWebmConvertionProgress.pipe(
      filter(data =>
        data.fileId === this.item.PlaylistItemLinks[this.sourceIndex].FileId &&
        data.percentage !== this.percentage),
      tap(data => {
        this.percentage = this.convertingMessage ? data.percentage : AppConstants.ZERO_DOWNLOADED_FILE;
        this.convertingMessage = PlaylistDialogMessagesEnum.PlaylistMP4ToWebmConvertingTitle;
      }),
      finalize(() => this.percentage = AppConstants.FULLY_DOWNLOADED_FILE)
    );

    this.mp4PortraitToLandscapeConverted$ = this.monitorHub.PortraitToLandscapeConvertionProgress.pipe(
      filter(data => data.fileId === this.item.PlaylistItemLinks[this.sourceIndex].FileId),
      tap(data => {
        this.percentage = data.percentage;
        this.convertingMessage = PlaylistDialogMessagesEnum.PlaylistMP4ConvertingTitle;
      })
    );

    this.presentationFileConverted$ = this.monitorHub.pptFileConverted.pipe(
      filter(convertedFile => convertedFile.fileId === this.item.PlaylistItemLinks[this.sourceIndex].FileId),
      tap(convertedFile => {
        ++this.transformedItemsAmount;
        this.percentage = (this.transformedItemsAmount / convertedFile.totalAmount) * AppConstants.FULLY_DOWNLOADED_FILE;
        this.convertingMessage = null;

        if (convertedFile.totalAmount === this.transformedItemsAmount) {
          convertedFile.totalAmount = AppConstants.ZERO_NUMBER;
          this.transformedItemsAmount = AppConstants.ZERO_NUMBER;
        }
      })
    );
  }
}
